<template>
  <div class="m-3">
    <div
      class="d-flex justify-content align-items-center mb-1 cursor-pointer mt-2"
      @click="back()"
    >
      <button
        class="btn btn-sm rounded-circle p-25"
        :class="isDark ? 'btn-danger' : 'btn-primary'"
      >
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div class="ml-1 text-capitalize text-dark goback-text">
        {{ $t("actions.go_back") }}
      </div>
    </div>
    <b-card v-if="loadingSearch">
      <div class="text-center my-5">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </b-card>
    <b-card-group
      v-else
      deck
      class="mb-2"
    >
      <b-card>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <h4 class="mb-2">
            {{ $t('operational_security.crisis_form.title') }}
          </h4>
          <b-form
            @submit.prevent="handleSubmit(save)"
            @reset.prevent="resetForm"
          >
            <div class="row">
              <div class="col-6">
                <validation-provider
                  #default="validationContext"
                  :name="$t('operational_security.crisis_form.name')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('operational_security.crisis_form.name')"
                    label-for="name"
                  >
                    <b-form-input
                      id="name"
                      v-model="operationalSecurityCrisis.name"
                      placeholder="Ingresar nombre"
                      :state="getValidationState(validationContext)"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-6">
                <validation-provider
                  #default="validationContext"
                  name="Tenant"
                  rules="required"
                >
                  <b-form-group
                    label="Tenant"
                    label-for="id_tenant"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      input-id="id_tenant"
                      v-model="operationalSecurityCrisis.id_tenant"
                      :options="tenantOptions"
                      placeholder="Seleccione tenant"
                      :reduce="(val) => val.value"
                      @input="tenantChanged"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-6">
                <validation-provider
                  #default="validationContext"
                  :name="$t('operational_security.crisis_form.level')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('operational_security.crisis_form.level')"
                    label-for="name"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      input-id="level"
                      v-model="operationalSecurityCrisis.level"
                      :options="['0','1','2','3','4','5']"
                      placeholder="Seleccione nivel"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-6">
                <validation-provider
                  #default="validationContext"
                  :name="$t('operational_security.crisis_form.responsable')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('operational_security.crisis_form.responsable')"
                    label-for="responsables"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      id="responsables"
                      v-model="operationalSecurityCrisis.supervisors"
                      :options="usersOptions"
                      placeholder="Seleccione responsable(s)"
                      :reduce="(val) => val.value"
                      :disabled="!operationalSecurityCrisis.id_tenant || !userCapabilities.canUpdateFormConfig"
                      class="w-100"
                      multiple
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <!-- CSIS Info -->
              <div class="col-6">
                <validation-provider
                  #default="validationContext"
                  name="CSIS días en campo"
                  rules=""
                >
                  <b-form-group
                    label="CSIS días en campo"
                    label-for="csis_days_in_field"
                    :state="getValidationState(validationContext)"
                  >
                    <b-form-input
                      id="csis_days_in_field"
                      v-model="operationalSecurityCrisis.csis_days_in_field"
                      placeholder="CSIS días en campo"
                      :state="getValidationState(validationContext)"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-6">
                <validation-provider
                  #default="validationContext"
                  name="CSIS total de voluntarios"
                  rules=""
                >
                  <b-form-group
                    label="CSIS total de voluntarios"
                    label-for="csis_total_volunteers"
                    :state="getValidationState(validationContext)"
                  >
                    <b-form-input
                      id="csis_total_volunteers"
                      v-model="operationalSecurityCrisis.csis_total_volunteers"
                      placeholder="CSIS total de voluntarios"
                      :state="getValidationState(validationContext)"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <!-- ----------------------------- -->
              <div class="col-12">
                <validation-provider
                  #default="validationContext"
                  :name="$t('operational_security.crisis_form.description')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('operational_security.crisis_form.description')"
                    label-for="description"
                    description="Máximo 4000 caracteres"
                  >
                    <b-form-textarea
                      id="description"
                      v-model="operationalSecurityCrisis.description"
                      placeholder="Ingresar descripción"
                      maxlength="4000"
                      rows="3"
                      max-rows="6"
                      :state="getValidationState(validationContext)"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    ></b-form-textarea>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>

              <!-- Templates Selector, Link Button & Linked Forms -->
              <div class="col-12" v-if="operationalSecurityCrisis.id">
                <hr/>
                <div class="row align-items-center mt-1">
                  <div class="col-8">
                    <b-form-group
                      label="Plantilla a Relacionar"
                      label-for="template_link"
                    >
                      <v-select
                        id="template_link"
                        v-model="selectedTemplate"
                        :options="templatesOptions"
                        label="name"
                        :reduce="(val) => val.id"
                        placeholder="Seleccione plantilla"
                        :disabled="!userCapabilities.canRelateForm && !hasValidUnits"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-4 text-left">
                    <b-button
                      variant="success"
                      :disabled="(!userCapabilities.canRelateForm && !hasValidUnits) || !selectedTemplate || loadingLink"
                      @click="linkForm"
                      style="margin-top: 5px !important;"
                    >
                      <b-spinner v-if="loadingLink" small class="mr-50"/>
                      <span class="text-nowrap">Relacionar formulario</span>
                    </b-button>
                  </div>
                  <div class="col-12">
                    <small class="d-inline-block text-muted" v-if="!hasValidUnits">
                      Agrega y valida al menos una instalación para poder relacionar
                      formularios
                    </small>
                  </div>
                </div>

                <!-- Linked Forms List -->
                <div class="row mt-1"
                     v-if="userCapabilities.canUpdateFormConfig || loadingLinkedForms || linkedForms.length > 0">
                  <div class="col-12">
                    <p class="mb-1 font-weight-bolder">Formularios Relacionados</p>
                    <div v-if="loadingLinkedForms" class="text-center my-1">
                      <b-spinner variant="primary" small></b-spinner>
                    </div>
                    <div v-else class="d-flex flex-column">
                      <b-link
                        v-for="form in linkedForms"
                        :key="form.id"
                        class="mb-50 text-primary font-weight-bold"
                        @click="goToLinkedForm(form.id)"
                      >
                        <feather-icon icon="LinkIcon" size="14" class="mr-50"/>
                        {{ form.label }}
                      </b-link>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ----------------------------- -->
            </div>
            <div v-if="userCapabilities.canUpdateFormConfig" class="text-right">
              <b-button
                type="submit"
                variant="primary"
                :disabled="loading"
              >
                <span class="text-nowrap">Guardar</span>
              </b-button>
              <b-button
                v-if="showMailOption(operationalSecurityCrisis)"
                type="button"
                variant="outline-primary"
                :disabled="loading"
                class="ml-1"
                @click="sendMail(operationalSecurityCrisis)"
              >
                <feather-icon icon="MailIcon" class="mr-50"/>
                <span>Enviar</span>
              </b-button>
              <!-- <b-dropdown v-if="operationalSecurityCrisis.id" id="dropdown-1" class="m-md-2" variant="outline-primary">
                 <template #button-content>
                  <feather-icon icon="MailIcon" class="mr-50" />
                  <span>Enviar</span>
                </template>
                <b-dropdown-item>Inicio de crisis</b-dropdown-item>
                <b-dropdown-item>Actualización de crisis</b-dropdown-item>
              </b-dropdown> -->
            </div>
          </b-form>
        </validation-observer>
      </b-card>
      <b-card>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <h4 class="mb-2">
            {{ $t('distribution_list.title') }}
          </h4>
          <b-form
            @submit.prevent="handleSubmit(save)"
            @reset.prevent="resetForm"
          >
            <div class="row">
              <div class="col-12">
                <validation-provider
                  #default="validationContext"
                  :name="$t('operational_security.crisis_form.to_list_id')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('operational_security.crisis_form.to_list_id')"
                    label-for="id_tenant"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      input-id="to_list_id"
                      v-model="operationalSecurityCrisis.to_list_id"
                      :options="distributionsList"
                      placeholder="Seleccione valor"
                      :reduce="(val) => val.value"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-12">
                <validation-provider
                  #default="validationContext"
                  :name="$t('operational_security.crisis_form.cc_list_id')"
                >
                  <b-form-group
                    :label="$t('operational_security.crisis_form.cc_list_id')"
                    label-for="cc_list_id"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      input-id="cc_list_id"
                      v-model="operationalSecurityCrisis.cc_list_id"
                      :options="distributionsList"
                      placeholder="Seleccione valor"
                      :reduce="(val) => val.value"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-12">
                <validation-provider
                  #default="validationContext"
                  :name="$t('operational_security.crisis_form.bcc_list_id')"
                >
                  <b-form-group
                    :label="$t('operational_security.crisis_form.bcc_list_id')"
                    label-for="cc_list_id"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      input-id="bcc_list_id"
                      v-model="operationalSecurityCrisis.bcc_list_id"
                      :options="distributionsList"
                      placeholder="Seleccione valor"
                      :reduce="(val) => val.value"
                      :disabled="!userCapabilities.canUpdateFormConfig"
                    />

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
            </div>
            <div v-if="userCapabilities.canUpdateFormConfig" class="text-right">
              <b-button
                type="submit"
                variant="primary"
                :disabled="loading"
              >
                <span class="text-nowrap">Guardar</span>
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
    </b-card-group>

    <template v-if="operationalSecurityCrisis.id">
      <b-card>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h4 class="mb-0">
            {{ $t('operational_security.crisis_form.unitsAdded') }}
          </h4>
          <b-button
            v-if="!isReadOnly"
            variant="outline-primary"
            @click="showModalUnitsList = true"
            :disabled="loading"
          >
            {{ $t('operational_security.crisis_form.addUnits') }}
          </b-button>
        </div>
        <template v-if="operationalSecurityCrisis.units.length">
          <p>
            Ultima actualización: <span class="font-italic">{{ lastLogDate }}</span>
          </p>
          <units-crisis
            :form-status="formStatus"
            :key="unitsKey"
            :last-status="lastStatus"
            :operational-security-crisis="operationalSecurityCrisis"
            :show-options-by-status="showOptionsByStatus"
            :user="userStore"
            :is-read-only="isReadOnly"
            :user-capabilities="userCapabilities"
            @build-data-from-response="buildOperationalSecurityCrisisFromResponse"
            @refresh-units="unitsKey++"
          />
        </template>
        <b-alert
          v-else
          show
          variant="warning"
          class="p-1 mb-0"
        >
          {{ $t('operational_security.crisis_form.emptyUnits') }}
        </b-alert>
      </b-card>

      <b-card>
        <div class="d-flex justify-content-between mb-2">
          <h4 class="mb-0">{{ $t('custom_forms.history') }}</h4>
          <strong class="text-muted">
            {{ operationalSecurityCrisis.validations.length }}
            {{ $t('custom_forms.entries') }}
          </strong>
        </div>
        <validations
          v-if="operationalSecurityCrisis.validations.length"
          :crisis-form-data="crisisFormData"
          :validations="operationalSecurityCrisis.validations"
        />
        <b-alert
          v-else
          show
          variant="warning"
          class="p-1 mb-0"
        >
          No hay validaciones
        </b-alert>
      </b-card>

      <logs-section
        ref="logsSectionRef"
        :crisis-id="operationalSecurityCrisis.id"
        @latest-log-date="lastLogDate = $event"
      />
    </template>

    <units-list-modal
      :operational-security-crisis="operationalSecurityCrisis"
      :show-modal-units-list="showModalUnitsList"
      @build-data-from-response="buildOperationalSecurityCrisisFromResponse"
      @update:isActive="showModalUnitsList = false"
    />
  </div>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import store from "@/store";
import axios from "@/libs/axios";
import router from "@/router";
import {required} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import {useToast} from "vue-toastification/composition";

import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import LogsSection from './components/LogsSection.vue';
import UnitsCrisis from './components/UnitsCrisis.vue';
import UnitsListModal from "./components/UnitsListModal.vue";
import Validations from "./components/Validations.vue";
import {
  useCrisisResponsePatch
} from './components/composables/response-patch/useCrisisResponsePatch';
import vSelect from "vue-select";


export default {
  components: {
    LogsSection,
    ToastificationContent,
    UnitsCrisis,
    UnitsListModal,
    ValidationProvider,
    ValidationObserver,
    Validations,
    vSelect
  },
  data() {
    return {
      required
    }
  },
  setup(_, {root}) {
    onMounted(async () => {
      const route = root.$route;

      if (route.params.id) {
        const idCrisisForm = route.params.id;

        await getCrisisForm(idCrisisForm);

        // Fetch templates and related forms only if the form is in edit mode
        await getTemplates();
        await getLinkedForms(idCrisisForm);
      }

      await getDistributionList();
      await store.dispatch('tenant/getAll');
    });

    const resetData = () => {
      operationalSecurityCrisis.value = {
        id: null,
        name: null,
        description: null,
        to_list_id: null,
        cc_list_id: null,
        bcc_list_id: null,
        supervisors: [],
        units: []
      }
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm
    } = formValidation(resetData);

    const toast = useToast();

    const crisisFormData = ref(null);
    const distributionsList = ref([]);
    const loading = ref(false);
    const loadingSearch = ref(false);
    const lastLogDate = ref(null);
    const logsSectionRef = ref(null);
    const unitsKey = ref(1)

    // Template linking refs
    const templatesOptions = ref([]);
    const selectedTemplate = ref(null);
    const loadingLink = ref(false);
    const isFormDisabled = ref(false);

    // Linked Forms refs
    const linkedForms = ref([]);
    const loadingLinkedForms = ref(false);

    const operationalSecurityCrisis = ref({
      id: null,
      name: null,
      level: null,
      description: null,
      csis_days_in_field: null,
      csis_total_volunteers: null,
      to_list_id: null,
      cc_list_id: null,
      bcc_list_id: null,
      id_tenant: null,
      supervisors: [],
      units: [],
      units_users_rh: [],
      last_status: null,
      validations: []
    });

    const showModalUnitsList = ref(false);
    const user = ref([]);
    const usersOptions = ref([]);

    //COMPUTED
    const formStatus = computed(() => ({
      withoutValue: (!lastStatus.value),
      inProgress: (lastStatus.value?.status.description === 'in_progress'),
      isRejected: (lastStatus.value?.status.description === 'rejected'),
      isApproved: (lastStatus.value?.status.description === 'completed'),
      isReview: (lastStatus.value?.status.description === 'review'),
      isReopen: (lastStatus.value?.status.description === 'reopened'),
      isCanceled: (lastStatus.value?.status.description === 'canceled')
    }));

    const tenantOptions = computed(() => store.getters['tenant/getSelectedItems']);
    const userStore = computed(() => store.getters["user/getUser"]);
    const hasUnits = computed(() => operationalSecurityCrisis.value?.units.length > 0);
    const hasValidUnits = computed(() => {
      if (!hasUnits.value) return false;
      const validUnits = operationalSecurityCrisis.value.units?.filter((unit) => {
        const invalidAffectIds = [14, 15, 16];

        return unit.affectsUnits.length && unit.affectsUnits.every(affect => !invalidAffectIds.includes(affect))
          || unit.operation_impact !== null
          || unit.out_off_comunication !== null
          || unit.damaged_cameras > 0;
      });

      return validUnits.length > 0;
    });
    const userCapabilities = computed(() => {
      const isOwner = crisisFormData.value?.owner && crisisFormData.value?.owner.id === userStore.value.id;
      const supervisorProfile = userStore.value.profile.type === 'supervisor_monitoreo';
      const isFormSupervisor = crisisFormData.value?.supervisors.some(sv => sv.id === userStore.value.id);
      const canUpdateFormConfig = isOwner || (isFormSupervisor && supervisorProfile) || userStore.value.is_master_admin;

      return {
        canUpdateFormConfig: crisisFormData.value ? canUpdateFormConfig : true,
        canRelateForm: crisisFormData.value ? hasValidUnits.value && (isOwner || isFormSupervisor) : hasValidUnits.value,
        isOwner: crisisFormData.value ? isOwner : true,
        supervisorProfile,
        isFormSupervisor,
      };
    });
    const isReadOnly = computed(() => !userCapabilities.value.isFormSupervisor && !userCapabilities.value.isOwner);

    const isDark = computed(() => store.state.appConfig.layout.skin === 'dark');

    const lastStatus = computed(() => operationalSecurityCrisis.value.last_status);

    const showOptionsByStatus = computed(() => (formStatus.value.inProgress || formStatus.value.isReopen || formStatus.value.isRejected || formStatus.value.withoutValue));

    const showSaveButtons = computed(() => {
      if (operationalSecurityCrisis.value.id) {
        if (!lastStatus.value) {
          return true;
        }

        // return (showOptionsByStatus.value && (userStore.value.id === lastStatus.value.id_user));
        return (showOptionsByStatus.value);
      }

      return showOptionsByStatus.value;
    });

    //METHODS
    const back = () => {
      router.push({name: 'crisis_form'});
    }

    // ===== Start: Crisis response patch flow =====
    // Delegates partial and full crisis response handling to a dedicated composable.
    const {
      buildOperationalSecurityCrisisFromResponse,
    } = useCrisisResponsePatch({operationalSecurityCrisis, tenantChanged});
    // ===== End: Crisis response patch flow =====

    // ===== Start: Crisis form loading =====
    // Loads the initial crisis payload and sends it through the replace flow.
    const getCrisisForm = async (crisisFormId) => {
      loadingSearch.value = true;

      await axios.get(`/v1/operational-security-crisis/${crisisFormId}`)
        .then(response => {
          const {data} = response;
          crisisFormData.value = data.data;
          buildOperationalSecurityCrisisFromResponse(data.data);
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loadingSearch.value = false;
        });
    }
    // ===== End: Crisis form loading =====

    const getDistributionList = async () => {
      await axios.get("/v1/distribution-lists")
        .then(response => {
          const {data} = response;

          distributionsList.value = data.data.map(dl => ({
            label: dl.name,
            value: dl.id
          }));
        })
        .catch(() => {

        });
    }

    // Fetch form templates for linking
    const getTemplates = async () => {
      try {
        const {data} = await axios.get('/v1/operational-security-crisis/link-form/templates');
        templatesOptions.value = data.data || [];
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error al obtener las plantillas',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    }

    // Fetch already linked forms
    const getLinkedForms = async (crisisId) => {
      loadingLinkedForms.value = true;
      try {
        const {data} = await axios.get(`/v1/operational-security-crisis/linked-forms/${crisisId}`);
        linkedForms.value = data.data || [];
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error al obtener los formularios relacionados',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        loadingLinkedForms.value = false;
      }
    }

    const linkForm = async () => {
      if (!selectedTemplate.value || !operationalSecurityCrisis.value.id) return;

      loadingLink.value = true;

      const payload = {
        id_operational_security_crisis: operationalSecurityCrisis.value.id,
        template: selectedTemplate.value
      };

      try {
        const {data} = await axios.post('/v1/operational-security-crisis/link-form', payload);

        toast({
          component: ToastificationContent,
          props: {
            title: 'Formulario relacionado exitosamente',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });

        // Trigger redirection using standard vue-router push
        if (data.data && data.data.form_id) {
          goToLinkedForm(data.data.form_id);
        }
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error al relacionar formulario',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        loadingLink.value = false;
      }
    }

    // Redirect to the external form answers page
    const goToLinkedForm = (formId) => {
      router.push({
        path: '/operational_security/form-answers',
        query: {edit: formId}
      });
    }

    const buildGeneralSettingsPayload = () => {
      const {
        id,
        name,
        description,
        level,
        csis_days_in_field,
        csis_total_volunteers,
        to_list_id,
        cc_list_id,
        bcc_list_id,
        reference_number,
        id_tenant,
        supervisors
      } = operationalSecurityCrisis.value;

      return {
        id,
        name,
        description,
        level,
        csis_days_in_field,
        csis_total_volunteers,
        to_list_id,
        cc_list_id,
        bcc_list_id,
        reference_number,
        id_tenant,
        supervisors
      };
    }

    const save = () => {
      loading.value = true;

      const isUpdate = Boolean(operationalSecurityCrisis.value.id);
      const method = isUpdate ? 'put' : 'post';
      const url = isUpdate ? `/v1/operational-security-crisis/${operationalSecurityCrisis.value.id}` : '/v1/operational-security-crisis';
      const payload = isUpdate ? buildGeneralSettingsPayload() : operationalSecurityCrisis.value;

      axios[method](url, payload)
        .then(response => {
          const {data} = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          buildOperationalSecurityCrisisFromResponse(data.data, {mode: isUpdate ? 'patch' : 'replace'});

          if (data.data && data.data.id) {
            logsSectionRef.value?.refresh(1);

            if (!isUpdate) {
              getTemplates();
              getLinkedForms(data.data.id);
            }
          }
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    // ===== Start: Tenant supervisor loading =====
    // Reloads valid supervisors whenever the crisis tenant changes.
    function tenantChanged(tenantId) {
      if (!tenantId) {
        usersOptions.value = []
        user.value = []
        return
      }

      axios.get(`/v1/operational-security-crisis/get-supervisors?id_tenant=${tenantId}`)
        .then(response => {
          const {data} = response;
          const _data = data.data;

          usersOptions.value = _data.map((u) => ({
            value: u.id,
            label: `${u.user} | ${u.full_name}`,
          }));

          const validIds = new Set(_data.map((u) => u.id));

          user.value = user.value.filter((id) => validIds.has(id));
        })
        .catch(error => {
          console.error('Error loading users:', error)
          usersOptions.value = []
          user.value = []
        });
    }

    // ===== End: Tenant supervisor loading =====

    const sendMail = (item) => {
      axios.get(`/v1/operational-security-crisis/${item.id}/send-email`)
        .then((response) => {
          const {data} = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        });
    }

    const showMailOption = (item) => {
      const {to_list_id, cc_list_id, bcc_list_id} = item;

      return (to_list_id && cc_list_id && bcc_list_id);
    }

    return {
      isFormDisabled,
      getValidationState,
      resetForm,
      refFormObserver,

      distributionsList,
      loading,
      loadingSearch,
      logsSectionRef,
      operationalSecurityCrisis,
      showModalUnitsList,
      user,
      usersOptions,
      unitsKey,

      formStatus,
      templatesOptions,
      selectedTemplate,
      loadingLink,

      linkedForms,
      loadingLinkedForms,

      isDark,
      lastLogDate,
      lastStatus,
      showOptionsByStatus,
      showSaveButtons,
      tenantOptions,
      userStore,
      crisisFormData,
      hasValidUnits,
      userCapabilities,
      isReadOnly,

      back,
      buildOperationalSecurityCrisisFromResponse,
      save,
      tenantChanged,

      linkForm,
      goToLinkedForm,
      sendMail,
      showMailOption,
    }
  }
}
</script>
